module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.915720dd.jpg";